<template>
    <div class="mainPage">
      <!-- 页头 -->
      <el-header height="100px">
        <div class="logoBox fl marginR10">
          <img src="@/assets/image/logo.png">
        </div>
        <div class="fm">
          <span>合肥成蹊科技</span>
        </div>
        <div class="headBox">
          <!-- 导航栏 -->
          <div class="navBox">
            <ul>
              <li @click="$router.push({path: '/home'})">首页</li>
              <li @click="$router.push({path: '/solution'})">解决方案</li>
              <li @click="$router.push({path: '/product'})">产品服务</li>
              <li @click="$router.push({path: '/consult'})">业务咨询</li>
              <li @click="$router.push({path: '/union'})">合作加盟</li>
              <li @click="$router.push({path: '/about'})">关于成蹊</li>
            </ul>
          </div>
        </div>
      </el-header>
      <!-- 页面主题 -->
      <el-main>
      <router-view></router-view>
      </el-main>
      <!-- 页尾 -->
      <el-footer height="100px">
        <div>
        <el-row>
          <el-col :span="6">
            <el-row>
              <el-col :span="6"><img src="@/assets/image/portal.png"></el-col>
              <el-col :span="6"><p>扫扫关注</p></el-col>
              <el-col :span="6"><img src="@/assets/image/cxtrace.png"></el-col>
              <el-col :span="6"><p>点点溯源</p></el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row> <span>合肥成蹊科技  版权所有   Copyright © 2020 Chengxi Tech Limited All Rights Reserved.</span></el-row>
            <el-row> <span>皖ICP备20002649号-1</span></el-row>
          </el-col>
          <el-col :span="6">
            <el-row style="text-align: left;"> <span>业务电话：13485715181</span></el-row>
            <el-row style="text-align: left;"> <span>技术支持：support@hfcx.org.cn</span></el-row>
          </el-col>
        </el-row>
        </div>
      </el-footer>
      </div>
</template>

<script>
export default {
  name: 'mainPage'
}
</script>

<style lang="less" scoped>
.el-header {
  width: 100%;
  z-index: 999;
  height: 120px;
  background: url('../assets/image/top_bg.jpg') no-repeat;
  background-size: 100%;
  border-bottom: 3px solid #f4f6f7;
  overflow: hidden;
  .logoBox {
    width: 60px;
    height: 60px;
    margin-top: 20px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .marginR10 {
    margin-right: 10px;
  }
  .fl {
    float: left;
  }
  .fm {
    margin-top: 20px;
    margin-left: 40px;
    float:left;
    font-size: 40px;
    color:white;
  }
  .fr {
    float: right;
  }
  .headBox {
    .navBox {
      ul {
        li {
          display: inline-block;
          line-height: 60px;
          height: 60px;
          text-align: center;
          color: #fff;
          font-size: 18px;
          padding: 0 18px;
          cursor: pointer;
          &:hover {
            color: #131e1f;
          }
        }
      }
    }
  }
}
.el-main {
  width: 100%;
  z-index: 999;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}
.el-footer {
  width: 100%;
  z-index: 999;
  height: 120px;
  background: #5c8ed8;
  margin-top: 3px;
  color: #fff;
  border-bottom: 3px solid #5c8ed8;
  overflow: hidden;
  img {
      width: 60px;
      height: 60px;
    }
}
.el-row {
  margin:10px;
  padding: 0px;
  img {
    margin: 0px;
  }
  span {
    padding-top: 20px;
  }
}
</style>
